import Ecg from "..";

const routes = [
    { name: "EcgVisitaList", path: "/paziente/publipeas/visitaecg", component: Ecg.VisitaEcg.EcgVisitaList, meta: { title: "Visita Ecg" } },
    { name: "EcgVisitaEdit", path: "/paziente/publipeas/visitaecg/edit/:id", component: Ecg.VisitaEcg.EcgVisitaEdit, meta: { title: "Visita Ecg" } },
    { name: "EcgVisitaView", path: "/paziente/publipeas/visitaecg/view/:id", component: Ecg.VisitaEcg.EcgVisitaView, meta: { title: "Visita Ecg" } },
];Ecg

export default routes;